import { AddressFields, PersonalInfoFields, PersonFields } from '../../models/form-models';

export function getPersonalInfoPersonFieldsRequiredSchema(dobOptional: boolean, taxIdOptional: boolean): PersonFields  {
    return {
        first_name: true,
        middle_name: false,
        last_name: true,
        gender: true,
        gender_identity: false,
        gender_identity_other: false,
        suffix: false,
        known_as: false,
        date_of_birth: !dobOptional,
        tax_id: !taxIdOptional,
    };
}

export const PersonalInfoMailingAddressRequiredSchema: AddressFields = {
    country: false,
    address1: false,
    address2: false,
    address3: false,
    city: false,
    state: false,
    postalCode: false,
};

export const BeneficiaryOrganizationMailingAddressRequiredSchema: AddressFields = {
    country: true,
    address1: true,
    address2: false,
    address3: false,
    city: true,
    state: true,
    postalCode: false,
};

export const BeneficiaryPersonMailingAddressRequiredSchema: AddressFields = {
    country: false,
    address1: false,
    address2: false,
    address3: false,
    city: false,
    state: false,
    postalCode: false,
};


export interface PersonalFormValues extends PersonalInfoFields {
    designation_salutation: string;

    // address
    mailing_address_1: string;
    mailing_address_2: string;
    mailing_address_3: string;
    mailing_country: string;
    mailing_city: string;
    mailing_state: string;
    mailing_postal_code: string;

    // phones
    business_phone_country_code: string;
    business_phone_area_code: string;
    business_phone_number: string;
    business_phone_formated: string;
    business_phone_extension: string;

    home_phone_country_code: string;
    home_phone_area_code: string;
    home_phone_number: string;
    home_phone_formated: string;
    home_phone_extension: string;

    mobile_phone_country_code: string;
    mobile_phone_area_code: string;
    mobile_phone_number: string;
    mobile_phone_formated: string;
    mobile_phone_extension: string;

    personal_email_address: string;
    office_email_address: string;
}


export const ClergyBioPersonalInfoMailingAddressRequiredSchema: AddressFields = {
    country: false,
    address1: true,
    address2: false,
    address3: false,
    city: true,
    state: true,
    postalCode: false,
};